import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postData } from '../utils'
import { reloadActiveRelations, reloadBatches, reloadSchool } from '../utils/loadStorage'
import { TankValuesArrayType } from '../types/apiResponse/tankTypes'

export type editBatchType = {
  batchName: string | null
  startDate: number | null
  filledTanks: string[]
  emptyTanks: TankValuesArrayType
}

const editBatchAPI = async (editBatchData: editBatchType, batchId: string) => {
  const response = await postData<string[]>(`/batch/edit/${batchId}`, editBatchData)

  reloadActiveRelations()
  reloadBatches()
  reloadSchool(response)

  return response
}

export const useEditBatch = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ editBatchData, batchId }: { editBatchData: editBatchType; batchId: string }) =>
      editBatchAPI(editBatchData, batchId),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tankInfo'] })
      queryClient.invalidateQueries({ queryKey: ['undoable'] })
    },

    onError: (error) => {
      console.log('Edit Batch API Error:', error)
    },
  })
}
